import { getDeviceAndBrowser } from '../../libs/utils';
export default {
    data() {
        return {
            platformInfo: {}
        }
    },
    created() {
        this.getDeviceAndBrowser()
    },
    methods: {
        getDeviceAndBrowser() {
            this.platformInfo = getDeviceAndBrowser();
            console.log(this.platformInfo, 'platformInfo---')
          },
    }
}


// WEBPACK FOOTER //
// ./src/mixin/platform.js